import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import AOS from 'aos'
import 'aos/dist/aos.css'
import './styles/global.scss'
import ScrollReveal from './directives/scrollReveal'
import CountTo from './components/CountTo.vue'

Vue.use(ElementUI)
Vue.directive('scroll-reveal', ScrollReveal)
Vue.component('CountTo', CountTo)

// 初始化 AOS 动画库
AOS.init({
  duration: 800,
  easing: 'ease-out-cubic',
  once: true,
  offset: 80,
  delay: 0
})

// 路由切换后刷新 AOS,使新页面元素重新触发动画
router.afterEach(() => {
  Vue.nextTick(() => {
    AOS.refresh()
  })
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
